export default __webpack_public_path__ + "static/badge-sale-ef199b354190c269af03c9acbde5ae9e.webp";